import Http from '../http'

export default {

  index(filter) {
    return Http.get(`/movements`, {params: {...filter}})
  },
  indexByEvent({event_id, company_id}) {
    return Http.get(`/events/${event_id}/movements`, {params: {company_id}})
  },


  create(movement){
    return Http.post(`/movements`, {movement: {
      ...movement,
    }})
  },

  createFormData(movement){
    return Http.post(`/movements`, movement)
  },

  update(movement){
    return Http.put(`/movements/${movement.id}`, {
      movement: {
        ...movement,
      },
    });
  },
  updateFormData(movement){
    return Http.put(`/movements/${movement.get("movement[id]")}`, movement)
  },

  show(id) {
    return Http.get(`/movements/${id}`);
  },

  delete(id){
    return Http.delete(`/movements/${id}`)
  }

}